export default "__VITE_ASSET__ClaXXaiZ__"